import React from "react";
import "../assets/css/Panel.css";
import Navbar from "../components/Navbar";
import GashtaltImage from "../assets/images/gavazn.png";
import {FaTelegram} from "react-icons/fa";


function AboutUs() {
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="row justify-content-center about-us-container">
                <div className="about-us col">
                    <h3>زیست کنکور به روش گشتالت:</h3>
                    <p className={"font-light-weight"}>
                        گروه آموزشی گشتالت در سال ۱۴۰۲ با هدف ارتقای نگاه دانش ‌آموزان به زیست کنکور و مطرح کردن دیدهای
                        اصلی طراحان
                        کنکور در طرح سوالات مختلف تاسیس شد. در واقع ما در گشتالت معتقدیم سال‌هاست که طراحان کنکور ثابت
                        مانده‌اند و
                        به جای نکته‌شناسی نکته‌محوری برای پاسخ به سوالات کنکور باید دیدهای طراحان را شناخت و دیدمحور بود.
                    </p>
                    <p className={"font-light-weight"}>
                        یکی از پایه‌های دید طراحان کنکور که گشتالت نیز نظریه‌ای به
                        همین مضمون می‌باشد آن است که:
                        <span>«کل هر چیز فراتر از اجتماع اجزای آن است»</span>.
                    </p>
                    <p className={"font-light-weight"}>
                        درست مانند تصویر مورد نظر که خط‌های عمودی متفاوت و متعددی کنار هم قرار گرفته‌اند و به تنهایی
                        معنایی ندارند اما وقتی که همدیگر را
                        تکمیل می‌کنند، گوزن ما را شکل می‌دهند. این همان چیزی است که در فصل ۱ کتاب دهم به عنوان یکی از
                        اصول نگاه به درس زیست
                        شناسی مطرح شده است.
                    </p>
                </div>
                <img src={GashtaltImage} alt={"خطا"} className={"col-12 col-lg-3"}/>
            </div>

        </div>
    );
}

export default AboutUs;
